import React, { useEffect } from "react";
import { useState } from "react";
import "./dashboardstyles.css"
import Notif from "../assets/notificationIcon"
import NotifRec from "../assets/notificationRec"
import UserIcon from "../assets/userIcon"
import PreferenceTracker from "../components/PreferenceTracker";
import CoinTracker from "../components/CoinTracker";
import NotificationPopUp from "../components/NotificationPopUp";
import dataService from "../services/dataService";
import localforage from "localforage";
import { Navigate } from "react-router-dom";

export default function Dashboard() {
    const [isCoin, setIsCoin] = useState(false)
    const [isNotif, setIsNotif] = useState(false)
    const [logOutPopUp, setLogOutPopUp] = useState(false)
    const [loggedOut, setLoggedOut] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [reRender, setRender] = useState(true)

    var coinClass = "coins"
    var preferencesClass = "preferences"

    useEffect(() => {
        (async () => {
            localforage.getItem("notifications").then(notifs => {
                localforage.getItem("preferences").then((prefs) => {
                    if (prefs != null) {
                        let newNotifsTemp = []
                        const coinComparisonUpdate = prefs.map((coin) => {
                            return dataService.getLiveRate(coin.coinId).then(res => {
                                const coinComparisonItem = { upper: parseFloat(coin.upper), lower: parseFloat(coin.lower), current: parseFloat(res.priceUsd), coinName: coin.coinName, coinId: coin.coinId }
                                return coinComparisonItem
                            })
                        })
                        Promise.allSettled(coinComparisonUpdate).then(results => {
                            localforage.getItem("coinAboveLimits").then(coinAboveLimits => {
                                localforage.getItem("coinBelowLimits").then(coinBelowLimits => {
                                    for (let i = 0; i < results.length; i++) {
                                        console.log(results)
                                        const comparisonItem = results[i].value
                                        let newNotificationItem = { read: false, coinId: comparisonItem.coinId, coinName: comparisonItem.coinName, current: comparisonItem.current }
                                        if (!coinBelowLimits.includes(comparisonItem.coinName)) {
                                            if (comparisonItem.current < comparisonItem.lower) {
                                                let item = { ...newNotificationItem }
                                                item.relation = "below"
                                                item.limit = comparisonItem.lower
                                                newNotifsTemp.push(item)
                                                coinBelowLimits.push(comparisonItem.coinName)
                                                localforage.setItem("coinBelowLimits", coinBelowLimits)
                                            }
                                        }
                                        else {
                                            if (comparisonItem.current > comparisonItem.lower) {
                                                const coinBelowLimitsModified = coinBelowLimits.filter((elem) => {
                                                    return elem !== comparisonItem.coinName
                                                })
                                                localforage.setItem("coinBelowLimits", coinBelowLimitsModified)
                                            }
                                        }
                                        if (!coinAboveLimits.includes(comparisonItem.coinName)) {
                                            if (comparisonItem.current > comparisonItem.upper) {
                                                let item = { ...newNotificationItem }
                                                item.relation = "above"
                                                item.limit = comparisonItem.upper
                                                newNotifsTemp.push(item)
                                                coinAboveLimits.push(comparisonItem.coinName)
                                                localforage.setItem("coinAboveLimits", coinAboveLimits)

                                            }
                                        }
                                        else {
                                            console.log(comparisonItem.current + ": " + comparisonItem.upper)

                                            if (comparisonItem.current < comparisonItem.upper) {
                                                const coinAboveLimitsModified = coinAboveLimits.filter((elem) => {
                                                    return elem !== comparisonItem.coinName
                                                })
                                                localforage.setItem("coinAboveLimits", coinAboveLimitsModified)
                                            }
                                        }
                                    }
                                    newNotifsTemp.forEach(element => {
                                        dataService.addNotificationDB(element.coinId, element.coinName, element.limit, element.current, element.relation, element.read)
                                    })

                                    const allNotifs = notifs.concat(newNotifsTemp)
                                    localforage.setItem("notifications", allNotifs).then(val => {
                                        setNotifications(allNotifs)
                                    })
                                })

                            })
                        })
                    }
                })
            })

        })()

        return () => {
            // this now gets called when the component unmounts
        };
    }, [])

    function switchPanel() {
        setIsCoin(!isCoin)
    }

    function triggerRender() {
        setRender(!reRender)
    }

    function showNotificationPopUp() {
        setIsNotif(!isNotif)
    }

    function showLogout() {
        setLogOutPopUp(!logOutPopUp)
    }

    function logOut() {
        localStorage.removeItem("username")
        localforage.removeItem("preferences").then(() => {
            localforage.removeItem("notifications")
        })
        setLoggedOut(true)
    }
    if (isCoin) {
        coinClass = "coins selectedButton"
        preferencesClass = "preferences"
    }
    else {
        coinClass = "coins"
        preferencesClass = "preferences selectedButton"
    }

    if (loggedOut) {
        return (
            <Navigate to="/" />
        )
    }
    else {
        return (
            <React.Fragment>
                <div className="col">
                    <div className="header row">
                        <div className="title">
                            cryptracker
                        </div>
                        <div className="user-bar row">
                            <Notif onClick={showNotificationPopUp} />
                            <div className="user-info row">
                                <div className="username">{localStorage.getItem("username")}</div>
                                <UserIcon onClick={showLogout} />
                            </div>
                            {isNotif && <NotificationPopUp notificationsProp={notifications} />}
                            {logOutPopUp && <div className="logout-popup" onClick={logOut}> logout</div>}
                        </div>
                    </div>
                    <div className="content col">
                        <div className="headerbuttons row">
                            <button className={coinClass} onClick={switchPanel}>coins</button>
                            <button className={preferencesClass} onClick={switchPanel}>preferences</button>
                        </div>
                        <div className="box">
                            {isCoin ? <CoinTracker /> : <PreferenceTracker triggerRender={triggerRender} />}
                        </div>
                    </div>
                </div>
            </React.Fragment >
        )
    }

}